<!--
 * @Date: 2020-09-01 09:42:44
 * @Author: MX
 * @Description:帮助中心
-->
<template>
  <div class="helpCenter main-wrap">
    <div class="helpCenter-wrap">
      <div class="main-left">
        <div class="main-left-header">
          <span class="line"></span>
          {{$t("帮助中心")}}
        </div>
        <div class="main-left-aside">
          <div class="main-left-aside-item" v-for="(item,index) in asideList" :key="index">
            <div class="title">
              {{$t(`helpCenter.${item.title}`)}}
            </div>
            <div class="subTitle" v-for="(subItem,subIndex) in item.subTitle" :key="subIndex" :class="{first:subIndex===0,active:tabNum === subIndex}" @click="subTip(subIndex)">
              {{$t(`helpCenter.${subItem}`)}}
            </div>
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="main-right-item" v-if="tabNum === 0">
          <h3>
            <i class="iconfont iconapiwendang_qianmingfangshi"></i>{{$t("helpCenter.签名工具")}}
          </h3>
          <div class="content">
            <h4 class="content-subTitle">{{$t("helpCenter.签名方式")}}</h4>
            <p>{{$t("helpCenter.method_1")}}</p>
            <p>{{$t("helpCenter.method_2")}}</p>
            <p>{{$t("helpCenter.method_3")}}</p>
            <p>{{$t("helpCenter.method_4")}}</p>
            <p>{{$t("helpCenter.method_5")}}</p>
            <p>{{$t("helpCenter.method_6")}}</p>
            <!-- <p>1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;</p>
                        <p>2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;</p>
                        <p>3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。</p>
                        <p>4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。</p>
                        <p>5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；</p>
                        <p>6. 部分接口示例代码和sdk请参考示例代码、SDK文档。</p> -->
            <h4 class="content-subTitle bodySign">{{$t("helpCenter.业务参数签名")}}</h4>
            <div class="flex justify_between  items_center">

              <table border cellspacing="0" cellpadding="0">
                <tr>
                  <td class="first">customerCode</td>
                  <td class="second">
                    <input type="text" v-model="accountSignForm.customerCode" :placeholder="`${$lang('请输入')} customerCode`">
                  </td>
                </tr>
                <tr>
                  <td class="first">pwd</td>
                  <td class="second">
                    <input type="text" v-model="accountSignForm.pwd" :placeholder="$t('helpCenter.请输入加密后的32位pwd')">
                  </td>
                </tr>
                <tr>
                  <td class="first">privatekey</td>
                  <td class="second">
                    <input type="text" v-model="accountSignForm.privateKey" :placeholder="`${$lang('请输入')} privatekey`">
                  </td>
                </tr>
              </table>

              <button class="commonBtn obtain" @click="accountSign">{{$t("helpCenter.获取")}}</button>
              <div class="line">
                <span class="line-key">digest</span>
                <span class="line-value">{{accountSignDigest}}</span>
              </div>
            </div>
            <section>
              <p v-html="$t('helpCenter.bussness')"></p>
              <p v-html="$t('helpCenter.bussness_1')">首先，极兔会分配一个协议客户下单所需的账号和密码。例如：<code>J0086024071</code>/<code>BaMCAx11</code>,其中<code>pwd</code>等于<code>MD5(明文密码(BaMCAx11)+jadada236t2)</code>
                后大写,比如此示例生成的32位<code>pwd</code>为<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>,最后按照规则Base64(Md5(客户编号+密文+privateKey))生成业务参数签名。</p>
              <p v-html="$t('helpCenter.bussness_2')">即：业务参数签名<code>digest</code>=Base64(Md5(<code>J0086024071</code>+<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>+privateKey))</p>
            </section>
            <h4 class="content-subTitle bodySign">{{$t('helpCenter.Headers签名')}}</h4>
            <div class="flex justify_between  items_center">
            <table border cellspacing="0" cellpadding="0">
              <tr>
                <td class="first">privatekey</td>
                <td class="second">
                  <input type="text" v-model="headersSignForm.privateKey" :placeholder="`${$lang('请输入')} privateKey`">
                </td>
              </tr>
              <tr>
                <td class="first signFirst">bizContent</td>
                <td class="second">
                  <textarea v-model="headersSignForm.json" :placeholder="`${$lang('请输入')} bizContent`"></textarea>
                </td>
              </tr>
            </table>
              <button class="commonBtn obtain" @click="headersSign">{{$t("helpCenter.获取")}}</button>
              <div class="line">
                <span class="line-key">digest</span>
                <span class="line-value">{{headersSignDigest}}</span>
              </div>
            </div>
            <section>
              <p v-html="$t('helpCenter.headers_1')">示例：
                以取消订单为例：假设业务参数为
                bizContent为<code>{"customerCode": "J0086024071","digest": " U40e5sumorgd3YgZzU","txlogisticId":
                  "10000000001299","reason": "YL1234567890123"}</code>,
                那么此时的header里面的签名digest等于<code>base64(md5(业务参数的Json+privateKey))</code>,</p>
              <p v-html="$t('helpCenter.headers_2')">即 <code>base64(md5({"customerCode": "J0086024071","digest": " U40e5sumorgd3YgZzU", "txlogisticId":
                  "10000000001299","reason": "YL1234567890123"}+privateKey))</code>。</p>
              <p v-html="$t('helpCenter.headers_3')">注：<code>privateKey</code>为账号通过平台认证后自动分配</p>
            </section>
          </div>
        </div>
        <div class="main-right-item" v-if="tabNum === 2">
          <h3>
            <i class="iconfont iconbangzhuzhongxin_dianzimiandanmoban"></i>{{$t('helpCenter.电子面单模板')}}
          </h3>
          <div class="content">
            <div class="down flex flex-center">
              <img src="../../assets/images/home/muban.png" alt="">
              <button class="commonBtn btn" @click="downloadOneTemplate(1)"><i class="iconfont iconxiazaimobanmoren"></i>
                {{$t('helpCenter.一联模版')}}</button>
            </div>
            <!-- <div class="down">
              <img src="../../assets/images/home/muban.png" alt="">
              <button class="commonBtn btn" @click="downloadOneTemplate(2)"><i class="iconfont iconxiazaimobanmoren"></i>
                二联模版</button>
            </div> -->
          </div>

        </div>
        <div class="main-right-item" v-if="tabNum === 1">
          <h3>{{$t('helpCenter.API开放平台-SDK')}}</h3>
          <Sdk-item></Sdk-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { RESPONSE_SUCCESS } from "@/constants";
import SdkItem from "./children/sdkItem";
export default {
  name: "helpCenter",
  components: { SdkItem },
  data() {
    return {
      asideList: [
        {
          title: "常用工具",
          // subTitle: ["签名工具", "电子面单模板", "API-SDK说明"],
          subTitle: ["签名工具", "API-SDK说明"],
        },
      ],
      tabNum: 0,
      accountSignForm: {
        customerCode: "",
        pwd: "",
        privateKey: "",
      },
      accountSignDigest: "",
      headersSignForm: {
        privateKey: "",
        json: "",
      },
      headersSignDigest: "",
    };
  },
  methods: {
    /**
     * @description  侧边点击
     */
    subTip(num) {
      this.tabNum = num;
    },
    /**
     * @description  账号秘钥签名
     */
    accountSign() {
      if (
        !this.accountSignForm.customerCode &&
        !this.accountSignForm.pwd &&
        !this.accountSignForm.privateKey
      ) {
        return this.$message.warning("请完整填写字段");
      }
      this.$API.accountSign(this.accountSignForm).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success("获取成功");
          this.accountSignDigest = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description  json秘钥签名
     */
    headersSign() {
      if (!this.headersSignForm.privateKey && !this.headersSignForm.json) {
        return this.$message.warning("请完整填写字段");
      }
      this.$API.headersSign(this.headersSignForm).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success("获取成功");
          this.headersSignDigest = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //下载模板
    async downloadOneTemplate(type) {
      const elink = document.createElement("a");
      elink.style.display = "none";
      if (type === 1) {
        elink.href = this.$API.downloadOneTemplate;
      } else if (type === 2) {
        elink.href = this.$API.downloadTwoTemplate;
      }
      elink.setAttribute("download", name);
      document.body.appendChild(elink);
      elink.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.helpCenter {
  background: #f4f5f7;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  ::v-deep code {
    font-size: 14px;
    word-wrap: break-word;
    padding: 2px 4px;
    border-radius: 4px;
    margin: 0 2px;
    color: #1e6bb8;
    background-color: rgba(27, 31, 35, 0.05);
    word-break: break-all;
  }
}
.helpCenter-wrap {
  padding: 20px 0;
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  .main-left {
    width: 240px;
    box-sizing: border-box;
    margin-right: 20px;
    background: #fff;
    border-radius: 10px;
    .main-left-header {
      position: relative;
      height: 71px;
      width: 100%;
      border-bottom: 1px solid $table-border-color;
      color: #2b2d42;
      font-size: 26px;
      font-weight: 900;
      line-height: 26px;
      padding: 22px 0 22px 20px;
      box-sizing: border-box;
      .line {
        width: 4px;
        height: 28px;
        background: $theme-color;
        border-radius: 2px;
        display: inline-block;
        position: absolute;
        left: 0;
        top: 22px;
      }
    }
    .main-left-aside {
      .main-left-aside-item {
        .title {
          font-size: 14px;
          color: #2b2d42;
          line-height: 14px;
          font-weight: 600;
          margin-top: 27px;
          padding: 0 20px;
        }
        .subTitle {
          font-size: 14px;
          font-weight: 400;
          color: #61666d;
          line-height: 16px;
          text-align: left;
          margin-top: 34px;
          cursor: pointer;
          box-sizing: border-box;
          padding: 0 20px 0 50px;
          &.first {
            margin-top: 30px;
          }
          &.active {
            font-weight: 600;
            color: $theme-color;
          }
        }
      }
    }
  }
  .main-right {
    flex: 1;
    background: #fff;
    box-sizing: border-box;
    padding: 50px 30px 15px;
    overflow: auto;
    border-radius: 10px;
    .main-right-item {
      h3 {
        font-size: 22px;
        color: #2b2d42;
        line-height: 22px;
        .iconfont {
          color: $theme-color;
          font-size: 24px;
          margin-right: 16px;
          font-weight: normal;
        }
      }
      .content {
        margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #61666d;
        line-height: 22px;
        .content-subTitle {
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          color: #2b2d42;
          line-height: 22px;
          margin-bottom: 10px;
          &.bodySign {
            margin: 50px 0 10px;
          }
        }
        p {
          margin-top: 15px;
          word-break: break-all;
        }
        table {
          position: relative;
          // border-collapse: collapse;
          border: 1px solid $table-border-color;
          border-radius: 4px;
          & > tr {
            border: none;
            &:nth-last-of-type(1) td {
              border-bottom: none;
            }
          }
          td {
            border: none;
            border-bottom: 1px solid $table-border-color;
            border-right: 1px solid $table-border-color;
            &:nth-last-child(1) {
              border-right: none;
            }
          }

          td.first {
            width: 120px;
            height: 40px;
            line-height: 40px;
            background: #f9fafc;
            text-align: center;
            color: #4c4d57;
            box-sizing: border-box;
            border-right: 1px solid $table-border-color;
            &.signFirst {
              height: 100px;
            }
          }
          td.second {
            width: 250px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            position: relative;
            box-sizing: border-box;
            overflow: hidden;
            input {
              border: none;
              width: 100%;
              height: 100%;
              outline: none;
              box-sizing: border-box;
              color: #61666d;
              padding: 12px;
              font-size: 14px;
            }
            textarea {
              border: none;
              width: 100%;
              height: 100%;
              outline: none;
              box-sizing: border-box;
              color: #61666d;
              padding: 12px;
              font-size: 14px;
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }

          .obtain {
            width: 100px;
            height: 40px;
            background: $theme-color;
            color: #fff;
          }
          .line {
            border: 1px solid $table-border-color;
            width: 370px;
            height: 40px;
            border-radius: 4px;
            .line-key {
              width: 120px;
              height: 40px;
              line-height: 40px;
              background: #f9fafc;
              text-align: center;
              color: #4c4d57;
              box-sizing: border-box;
              border-right: 1px solid $table-border-color;
              float: left;
            }
            .line-value {
              width: 250px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              box-sizing: border-box;
              float: left;
            }
          }
      }
      .down {
        display: inline-block;
        text-align: center;
        img {
          display: block;
          width: 100px;
          height: 100px;
          font-size: 0;
          margin: auto;
        }
        .btn {
          height: 32px;
          border: 1px solid #b0b3b6;
          margin-top: 12px;
          &:active,
          &:hover {
            color: $theme-color;
            border-color: $theme-color;
          }
        }
        &:last-of-type {
          margin-left: 40px;
        }
      }
    }
  }
}
[dir="rtl"] .helpCenter-wrap {
  .main-left {
    margin-left: 20px;
    margin-right: 0px;
    .main-left-header {
      padding: 22px 20px 22px 5px;
      .line {
        left: inherit;
        right: 0;
      }
    }
    .main-left-aside .main-left-aside-item .subTitle {
      padding: 0 50px 0 20px;
      text-align: right;
    }
  }
  .main-right {
    .main-right-item h3 .iconfont {
      margin-left: 16px;
      margin-right: 0px;
    }
  }
}
</style>
